import script from "./DetailComp.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailComp.vue?vue&type=script&setup=true&lang=js"

import "./DetailComp.vue?vue&type=style&index=0&id=38a04a59&lang=scss"

const __exports__ = script;

export default __exports__